import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "react-form-builder2/dist/app.css";
import { useParams } from "react-router";
import NotificationSettings from "../../components/rigcheck/notificationSettings/NotificationSettings";

const SingleRigcheckSubmission = () => {
    
    const { rigcheckId } = useParams();

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <NotificationSettings rigcheckId={rigcheckId} />
      </div>
    </div>
  );
};

export default SingleRigcheckSubmission;